import { render } from "./RecuperarSenha.vue?vue&type=template&id=905c516c&scoped=true"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"

import "./RecuperarSenha.vue?vue&type=style&index=0&id=905c516c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905c516c"]])

export default __exports__